
























import {Component, Vue, Prop} from 'vue-property-decorator';
import {
  Action,
} from 'vuex-class';

@Component
export default class DlgFileDelete extends Vue {
  @Prop({type: Object, default: null}) private file!: any;
  @Action('files/read') private filesRead!: any;
  @Action('files/del') private filesDelete!: any;

  private loading: boolean = false;
  private dialog: boolean = false;

  private del() {
    this.loading = true;
    this.filesDelete(this.file)
      .then((res: boolean) => {
        this.loading = false;
        if (res) {
          this.filesRead();
          this.dialog = false;
        }
      });
  }
}
